import React from 'react';
import ReactDOM from 'react-dom';
import { withTranslation } from 'react-i18next';
import { Notification } from '@workboard/wobo-ui'

import ImgIconComp from '../imgcomp';
import CommonTags from './commonTags';

import WobTypeTopic from './wobTypeTopic';
import DeleteTakeawayPopup from './modals/deleteTakeawayPopup';
import ListenerComponent from './listenerComponent';

import { allowFileUpload } from '../../utils/common';
import MeetingServices from "../../services/meeting.services";
import { v4 as uuidv4 } from 'uuid';
import { generateSASAnduploadToTempLocation, WoboFileUploadService } from '../../../src/services/fileupload.service';

import GoalServices from "../../../src/services/goal.services";
import { getAiTypeActionLabel } from '../../board/utils';

const services = new GoalServices();
// List Second section of topic view
class TitleOfAi extends ListenerComponent {
  constructor (props) {
    super(props);
    this.state = {
      ...this.state,
      type: 'topic',
      editTopicDescEdit: false,
      wb_type: false,
      act: 'edit',
      AddTopicToTemplate: (this.props.topicMiddle.recurringTopic == 0),
      enAddedBy: false,
      bottomTop: 0,
      showDeleteTopicError: false
    };
    this.refreshLegacyData = props.refreshLegacyData;
    this.MeetingServices = new MeetingServices();
    this.mouseover = this.mouseover.bind(this);
    this.mouseout = this.mouseout.bind(this);
    this.showFuncTopicList = this.showFuncTopicList.bind(this);
    this.hideSubmenuOptsDiv = this.hideSubmenuOptsDiv.bind(this);
    this.deleteTopic = this.deleteTopic.bind(this);
    this.shareMeetingTopic = this.shareMeetingTopic.bind(this);
    this.initDatePicker = this.initDatePicker.bind(this);
    this.remindTopicMeClick = this.remindTopicMeClick.bind(this);
    this.saveReminder = this.saveReminder.bind(this);
    this.convertToActionItem = this.convertToActionItem.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.addRecurringTopic = this.addRecurringTopic.bind(this);
    this.removeRecurringTopic = this.removeRecurringTopic.bind(this);
    this.deleteTopicAttach = this.deleteTopicAttach.bind(this);
  }

  componentDidMount () {
    window.addEventListener('pushState', this.handleGlobalStateChange);
  }

  componentWillUnmount () {
    window.removeEventListener('pushState', this.handleGlobalStateChange);
  }

  mouseover (id, desc) {
    if (desc != '' && !this.state.isSomethingPending) {
      $(`.topicShowMenu_${id}`).removeClass('dispNone').addClass('dispBk');
    }
  }

  mouseout (id, desc) {
    $(`.topicShowMenu_${id}`).removeClass('dispBk').addClass('dispNone');
  }

  showFuncTopicList (e, id) {
    $(`.topicsListDropdown_${id}`).show();
    this.setState({ enAddedBy: id });
    const offset = $(e.target).position();
    const { top } = offset;

    if ($('.meetingTopicTakeDetails').length && $('.meetingTopicTakeDetails').length > 3 && $('.meetingTopicTakeDetails:last').hasClass(`dragRows_${id}`) && $(`.topicsListDropdown_${id}`).height() > 120) {
      this.state.bottomTop = top - 150;
    } else {
      this.state.bottomTop = 0;
    }
  }

  hideSubmenuOptsDiv (id) {
    $(`.topicsListDropdown_${id}`).hide();
    this.setState({ enAddedBy: false });
  }

  deleteTopic (id, meetingId, type, files) {
    const topicHasTakeaways = this.props.topicMiddle.topic_take.length > 0
    const { isFUSEnabled } = this.props;
    if (topicHasTakeaways) {
      this.setState({
        showDeleteTopicError: true
      })
    } else {
      const topicId = '';
      delete_meeting_confirm.dialog('open');
      if (document.getElementById('delete-meeting-confirm-box')) {
        ReactDOM.unmountComponentAtNode(document.getElementById('delete-meeting-confirm-box'));
      }
      ReactDOM.render(<DeleteTakeawayPopup id={id} meetingId={meetingId} type={type} topicId={topicId} deleteTopicTakeNonTake={this.props.deleteTopicTakeNonTake} isFUSEnabled={isFUSEnabled} files={files} />, document.getElementById('delete-meeting-confirm-box'));
    }
  }

  convertToActionItem (e, topicId) {
    const { meeting } = this.props
    const params = {
      meetingId: meeting.id,
      type: 'topic',
      topicId,
      tag: 1, // tag = 1 represents AIs, vs OKRS and KRS
      ...(meeting?.ws_id ? { tagId: meeting?.ws_id } : {}),
    }
    this.MeetingServices.saveMeetingAI(params)
        .then(resp  => {
          this.refreshLegacyData(resp.data.data);
        });
  }

  shareMeetingTopic (topic) {
    this.props.shareMeetingTopic(topic);
  }

  initDatePicker (obj, id) {
    this.datetimepicker = $(obj);
    const _this = this;
    const { t } = this.props;
    $(this.datetimepicker).datetimepicker({
      dateFormat: 'yy-mm-dd',
      timeFormat: 'hh:mm tt',
      minDateTime: 0,
      controlType: 'select',
      currentText: t('Cancel'),
      closeText: 'Set',
      beforeShow (input, inst) {
        $('#ui-datepicker-div').addClass('dataTimePicker');
        setTimeout(() => {
          inst.dpDiv.css({
            marginLeft: '-20px',
          });
        }, 1);
      },
      onClose (date) {
        function isDonePressed () {
          return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
        }
        if (isDonePressed()) {
          _this.saveReminder($(this), date, id);
        }
      },
    }).datetimepicker('show');
  }

  remindTopicMeClick (id) {
    this.initDatePicker(`#remindTopicMe_${id}`, id);
  }

  saveReminder (obj, date, id) {
    const url = remindMeMeetingItemsUrl;
    const type = 'topic';
    if (typeof id !== 'undefined') {
      const posting = $.post(url, { id, type, dateAndTime: date }, () => {
      }).done((res) => {
      });
    }
  }

  deleteTopicAttach(topicId, id, type, fileSignature) {
    const { isFUSEnabled  } = this.props;
    if (isFUSEnabled && fileSignature) {
      WoboFileUploadService.delete(fileSignature)
    }
    $.get(`${wbConfig.baseUrl}/meeting/deleteAttachment`, { id, meeting_id:this.props.meeting.id,json: true }, (resp) => {
      if (resp.status == 'ok') {
        create_topic('meet', {
          action: 'delete_topic_attc',
          type: 'topic',
          data: { id },
          topicId,
        });
      }
    });
    this.props.deleteTopicAttach(topicId, id);
  }

  handleFileChange (e, topicId) {
    // TODO: all of this needs to get moved/refactored; how much is common to other code locations?
    e.preventDefault();
    const { t } = this.props;
    const _this = this;
    const file = e.target?.files[0];
    const topicMiddleDet = this.props.topicMiddle;
    const {
      isFUSEnabled, userId, orgId, appinID, accessToken , currentUser
    } = this.props;
    const resp = _this.props.mtS3Data;
    if (!file) {
      return;
    }
    if (file.size > upload_max_size) {
      alert(t('The file you have uploaded exceeds the maximum size of {{upload_max_size_configured}}MB.', { upload_max_size_configured: upload_max_size }));
      return;
    }

    const extension = file.name.split('.').pop();
    if (!allowFileUpload('meetings', extension)) {
      alert(t('The file type you have uploaded is not supported.'));
      return;
    }

    const afterUpload = function (wfile) {
      const params = {
        s3key: wfile.key,
        prefix: resp.prefix,
        fileName: replaceSpcicalCharacter(wfile.name),
        fileSize: wfile.size,
        s3DirectUpload: wfile.s3DirectUpload,
        object_id: topicId,
        object_type: 'topic'
      };
      $.ajax({
        url: meetingAttachUrl,
        type: 'POST',
        data: params,
        dataType: 'json',
        async: true,
      })
        .done((response) => {
          if (window.wbConfig.isNewMeetingsEnabled) {
            window.hideAppLoader();
          } else {
            removeLoaderWidget();
          }
          if (typeof response.error !== 'undefined') {
            alert(response.error);
            return;
          }
          let ListOfFile = response.data;
          ListOfFile = ListOfFile.filter(item => item.id == response.fileId);
          _this.props.addTopicAttach(topicMiddleDet.id, ListOfFile[0]);
          if (Array.isArray(ListOfFile) && ListOfFile.length) {
            create_topic('meet', {
              action: 'add_topic_attc',
              data: ListOfFile[0],
              type: 'topic',
              topicId: topicMiddleDet.id,
            });
          }
        })
        .fail((xhr, status, error) => {
          if (window.wbConfig.isNewMeetingsEnabled) {
            window.hideAppLoader();
          } else {
            removeLoaderWidget();
          }
          console.error(error);
          _this.errorFileUploading;
        });
    }

    const updateFile = (signature, delayMs, fileId) => {
      const _this = this;
      const clearTimer = setInterval(async () => {
        services
          .getFileStatus({ signature })
          .then((response) => {
            const jsonData = response?.data
            if (jsonData) {
              if (
                jsonData?.resp?.fus_type == 1 &&
                jsonData?.resp?.fus_status == 1 &&
                jsonData?.resp?.path
              ) {
                clearInterval(clearTimer)
                let ListOfFile = jsonData.resp;
                console.log(topicMiddleDet);
                _this.props.updateTopicAttach(topicMiddleDet.id, ListOfFile);
              }
            }
          })
          .catch((err) => {})
      }, delayMs)
    }

    const callUpload = function () {
      if (window.wbConfig.isNewMeetingsEnabled) {
        window.showAppLoader();
      } else {
        showLoaderWidget();
      }
      // If FUS enabled then allow the user to upload the file using FUS
      if (isFUSEnabled) {
        let request_id = uuidv4();
        let targetFolderName = uuidv4();

        generateSASAnduploadToTempLocation(file, {
          appinID,
          request_id,
          accessToken,
          userId,
          orgId,
        }).then((newFilename) => {
          if (newFilename) {
            const fileName = createFilename(file.name)
            const fileSize = file.size;
            const prefix = newFilename
            const params = {
              fileName,
              prefix,
              link_type: 1,
              s3DirectUpload: 2,
              fus_type: 1,
              fus_status: 2,
              fileSize,
              object_id: topicId,
              object_type: 'topic'
            }
            $.ajax({
              url: `${wbConfig.baseUrl}/meeting/addMeetingAttachment`,
              type: 'POST',
              data: params,
              dataType: 'json',
              async: true,
            })
              .done((response) => {
                // Polling to get the data and update the attachment details
                const fileObj = {
                  source_fileName: newFilename,
                  file_mimetype: file.type,
                  file_size: file.size,
                  request_id: request_id,
                  signature: prefix,
                  appInID: "woboclient", // Client app id and the same name for client container in the azure
                  byok_tenant_id: "", // this is the tenant id for encrypting the file with
                  file_originalname: fileName, // Name of the file
                  webhook_details: {
                    "host": `${wbConfig.baseDomainUrl}/fus/fusCallback?type=1`,
                    "path": "",
                  },
                  orgId: currentUser.org_id, // Organization id
                  userId: currentUser.id, // User id of the requested user
                  target_folder: targetFolderName, // Name of the target folder inside the target container,
                }
                
                if (window.wbConfig.isNewMeetingsEnabled) {
                  window.hideAppLoader();
                } else {
                  removeLoaderWidget();
                }
                if (typeof response.error !== 'undefined') {
                  alert(response.error);
                  return;
                }
                let ListOfFile = response.data;
                ListOfFile = ListOfFile.filter(item => item.id == response.fileId);
                _this.props.addTopicAttach(topicMiddleDet.id, ListOfFile[0]);
                if (Array.isArray(ListOfFile) && ListOfFile.length) {
                  create_topic('meet', {
                    action: 'add_topic_attc',
                    data: ListOfFile[0],
                    type: 'topic',
                    topicId: topicMiddleDet.id,
                  });
                }
                WoboFileUploadService.processFile(fileObj).then(() => {
                  updateFile(prefix, 15000, ListOfFile[0].id);
                }).catch((err) => {
                  _this.deleteTopicAttach(topicMiddleDet.id,  ListOfFile[0].id, 'topic',  ListOfFile[0].fileSignature )
                })
                removeLoaderWidget();
              })
              .fail(() => {
                console.error(t('Something went wrong, please try again later.'));
              })
          }
        })
      } else {
        $.ajax({
          url: `${wbConfig.baseUrl}/workboard/GetS3Data`,
          type: 'GET',
          dataType: 'json'
        })
          .done(resp => {
            const prefix = { resp };
            file.prefix = prefix;
            file.key = replaceS3Key(resp.key, file.name);
            if (resp.encrypt_type === 'azure:sse') {
              // upload file to Azure file storage
              uploadFileToAzureStorage(resp.asc, file.key, file)
                .then(result => {
                  file.s3DirectUpload = 2;
                  afterUpload(file);
                })
                .catch(error => {
                  console.error(error);
                });
            } else {
              // upload SIGNED file to AWS S3
              uploadSignedFileToS3Storage({ resp, file })
                .then(result => {
                  file.s3DirectUpload = 1;
                  afterUpload(file);
                })
                .catch(error => {
                  console.error(error);
                });
            }
          })
          .fail(() => {
            removeLoaderWidget();
            _this.errorFileUploading;
          });
      }
    }

    if (window.FileReader && window.Blob) {
      const filereader = new FileReader();
      filereader.onloadend = function (evt) {
        if (evt.target.readyState === FileReader.DONE) {
          const uint = new Uint8Array(evt.target.result);
          const bytes = [];
          $.each(uint, (i, byte) => {
            bytes.push(byte.toString(16));
          });
          const hex = bytes.join('').toUpperCase();
          if (hex == '4D5A900' || hex == '4D5A5000' || hex == 'FE49BCB') {
            alert(t('The file type you have uploaded is not supported.'));
            return;
          }
          callUpload();
        }
      };
      const blob = file.slice(0, 4);
      filereader.readAsArrayBuffer(blob);
    } else {
      callUpload();
    }
  }

  addRecurringTopic (e, topicId) {
    const { meeting, actions } = this.props;
    const value = 1;
    this.setState({
      AddTopicToTemplate: false,
    });
    $.post(`${wbConfig.baseUrl}/restapi/meetings/${meeting.id}/addRecurringTopic/${topicId}`, null, (response, status) => {
      if (response.error) {
        window.history.pushState({createAIError: response.error}, '', window.location.href);
      } else if (status == "success") {
        actions.MeetingItemAddRemoveRecurring(topicId, value);
      }
    });
  }

  removeRecurringTopic (e, topicId) {
    const { meeting, actions } = this.props;
    const value = 0;
    this.setState({
      AddTopicToTemplate: true,
    });
    $.post(`${wbConfig.baseUrl}/restapi/meetings/${meeting.id}/removeRecurringTopic/${topicId}`, null, (response, status) => {
      if (response.error) {
        window.history.pushState({createAIError: response.error}, '', window.location.href);
      } else if (status == "success") {
        actions.MeetingItemAddRemoveRecurring(topicId, value);
      }
    });
  }

  render () {
    const { meeting, t } = this.props;
    const topicMiddleDet = this.props.topicMiddle;
    const { updateTopicTake } = this.props;
    const { currentUser } = this.props;
    const badgePermission = (topicMiddleDet.added_by != currentUser.id);
    const shareUnshare = (topicMiddleDet.access == 1) ? t('Make private') : t('Share topic');
    const perShareEnable = (meeting.type == 1);
    const leftPost = (topicMiddleDet.wobo_type) == 'topic' ? 'leftPos' : 'leftPosempty';

    const { userPermission } = this.props;
    const executeModule = userPermission.execute || false;
    let enableDiv = false;
    const itemAcces = topicMiddleDet.access == 1;
    const sharePerm = (topicMiddleDet.added_by == currentUser.id);

    const sharePermission = (perShareEnable && sharePerm && itemAcces) || (perShareEnable && sharePerm);
    const isTopicEmpty = topicMiddleDet.description == '' || topicMiddleDet.description == '\n';
    if (userPermission.notesAccess || currentUser.id == topicMiddleDet.added_by || isTopicEmpty) {
      enableDiv = true;
    }
    const enableMeetingRecurring = !!((userPermission.meetingAccess && (meeting.interval > 0 || meeting.provider_series_id || meeting.series_id)));

    const woboTypeTopic = !!((topicMiddleDet.wobo_type === 'topic' && topicMiddleDet.tag != 1));
    const fromThreeDot = 1;
    // topicMiddleDet.hoverName = this.state.enAddedBy;
    topicMiddleDet.hoverName = topicMiddleDet.id;
    const wsId = meeting.ws_id;
    const files = topicMiddleDet.wobo_type === 'attachment' ?  topicMiddleDet.wobo_data : topicMiddleDet.files;
    const label = getAiTypeActionLabel().toLowerCase();
    return (
      <div className="wb-table-col wb-table-col-title titleAlignLeft" onMouseOver={() => this.mouseover(topicMiddleDet.id, topicMiddleDet.description)} onMouseOut={() => this.mouseout(topicMiddleDet.id, topicMiddleDet.description)} data-topic-id={topicMiddleDet.id} style={(woboTypeTopic) ? { width: '100%' } : {}}>
        <div className="topicConetentSec topicContainer">
          <div className={(meeting.status == 2) ? `floatRight dispNone topicHideMenuSec threeDotImage  topicShowMenu_${topicMiddleDet.id} ${leftPost}` : `floatRight dispNone topicHideMenuSec topicShowMenu_${topicMiddleDet.id} ${leftPost}`}>
            <div className="dispIB fucImg" onClick={e => this.showFuncTopicList(e, topicMiddleDet.id)} onMouseLeave={() => this.hideSubmenuOptsDiv(topicMiddleDet.id)}>
              <ImgIconComp id="artboard" class="memberPic" width="20" height="23" />
              <div className={`wspopupmenu-wrapper dispNone topicFuncList topicHeadsubMenuSec topicsListDropdown_${topicMiddleDet.id}`} style={{ top: this.state.bottomTop }} onClick={() => this.mouseout(topicMiddleDet.id)}>
                {
                  sharePermission
                  && (
                  <div className="wspopupmenu-list clickable  wb-meeting-unsharethis" data-id={topicMiddleDet.id} onClick={() => this.shareMeetingTopic(topicMiddleDet)}>
                    {shareUnshare}
                  </div>
                  )
                  }
                {
                  (woboTypeTopic && enableDiv)
                    ? <CommonTags ai_id={topicMiddleDet.ai_id} key={`topic_${topicMiddleDet.id}`} meeting={meeting} owner={topicMiddleDet.added_by} userPermission={this.props.userPermission} currentUser={this.props.currentUser} tag={topicMiddleDet.tag} topicId={topicMiddleDet.id} type={this.state.type} act={this.state.act} meetingId={meeting.id} id={topicMiddleDet.id} saveTags={this.props.saveTags} fromThreeDot={fromThreeDot}/>
                    : ''
                  }
                {!isTopicEmpty && <div className="wspopupmenu-list clickable  wb-meeting-topic-add" data-type="topic" data-meeting-id={meeting.id} data-topic-id={topicMiddleDet.id} data-type-id="topic">
                    {t('Add to another meeting')}
                  </div>
                }
                {
                  (enableMeetingRecurring && meeting.status == 1 && !isTopicEmpty)
                    ? (
                      <div>
                        {
                        (this.state.AddTopicToTemplate)
                          ? (
                            <div className="wspopupmenu-list clickable " data-type="topic" data-meeting-id={meeting.id} data-topic-id={topicMiddleDet.id} data-type-id="topic" onClick={event => this.addRecurringTopic(event, topicMiddleDet.id)}>
                              {t('Make topic recurring')}
                            </div>
                          )
                          : (
                            <div className="wspopupmenu-list clickable" data-type="topic" data-meeting-id={meeting.id} data-topic-id={topicMiddleDet.id} data-type-id="topic" onClick={event => this.removeRecurringTopic(event, topicMiddleDet.id)}>
                              {t('Remove from template')}
                            </div>
                          )
                        }
                      </div>
                    )
                    : ''
                  }
                {
                    enableDiv && !isTopicEmpty && executeModule && (topicMiddleDet.ai_id == null) && topicMiddleDet.tag != 1 && topicMiddleDet.wobo_type === 'topic' && topicMiddleDet.wobo_type !== 'attachment' && topicMiddleDet.wobo_type !== 'attachment_link'
                    && (
                    <div className="wspopupmenu-list clickable " data-type="topic" data-meeting-id={meeting.id} data-topic-id={topicMiddleDet.id} data-type-id="topic" onClick={event => this.convertToActionItem(event, topicMiddleDet.id)}>
                      {t('Convert to {{labelVar}}', { labelVar: label })}
                    </div>
                    )
                  }
                {
                  ( topicMiddleDet.wobo_type !== 'attachment' && topicMiddleDet.wobo_type !== 'attachment_link') && !window.wbConfig.isMeetingsFileUploadHidden &&
                  <div className="attachment-list clickable " data-meeting-id={meeting.id} data-type="topic" data-topic-id={topicMiddleDet.id}>
                    <label className="displayCell clickable" htmlFor={`file_input_new_${topicMiddleDet.id}`} style={{ display: 'inline-block', width: '184px', fontSize: '14px' }}>
                      {t('Add attachment')}
                      <input type="file" name="file" id={`file_input_new_${topicMiddleDet.id}`} ref="topicAddAttach" onChange={e => this.handleFileChange(e, topicMiddleDet.id)} style={{ display: 'none' }} />
                    </label>
                  </div>
                }
                <div className="wspopupmenu-list clickable  wb-meeting-remindme" data-type="topic" onClick={() => this.remindTopicMeClick(topicMiddleDet.id)}>
                  <input
                    className={`clickable remindDate remindMe_${topicMiddleDet.id}`}
                    type="text"
                    name="meeting_remind_me"
                    id={`remindTopicMe_${topicMiddleDet.id}`}
                    style={{
                      height: '0px', width: '0px', border: '0px', padding: '0px'
                    }}
                  />
                  {t('Remind Me')}
                </div>
                {
                  enableDiv
                  && (
                  <div className="wspopupmenu-list clickable  wb-meeting-topic-add" onClick={() => this.deleteTopic(topicMiddleDet.id, meeting.id, this.state.type, files)}>
                    {t('Delete')}
                  </div>
                  )
                  }
                {
                  badgePermission
                  && (
                  <div className="wspopupmenu-list clickable  clickable sendBadge" data-type="topic" data-member-id={meeting.user_id}>
                    {t('Give Feedback')}
                  </div>
                  )
                  }
              </div>
            </div>
          </div>
          <WobTypeTopic
            topicDet={topicMiddleDet}
            userPermission={userPermission}
            editTopicTextDesc={this.editTopicTextDesc}
            updateTopicTake={updateTopicTake}
            tagId={this.props.tagId}
            editTopicDescEdit={this.props.editTopicDescEdit}
            meetingObj={meeting}
            enableDiv={enableDiv}
            enAddedBy={topicMiddleDet.id}
            mtS3Data={this.props.mtS3Data}
            actions={this.props.actions}
            meeting={meeting}
            disableHoverStick={this.props.disableHoverStick}
            isNoAttachmentDownload={this.props.isNoAttachmentDownload}
            displayKrConfidence={this.props.displayKrConfidence}
            isTopicEmpty={isTopicEmpty}
            isFUSEnabled={this.props.isFUSEnabled}
            t={t}
          />

        </div>
        { this.state.showDeleteTopicError
          && (
            <Notification
              open
              message={t('Unable to delete Topics with Takeaways. Please delete all Takeaways first.')}
              severity="error"
              anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
              persist
              onClose={() => {
                this.setState({
                  showDeleteTopicError: false
                })
              }}
            />
          )}
      </div>
    );
  }
}
export default withTranslation()(TitleOfAi);
